var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashFlow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18.88 21.333a.85.85 0 00-.88.812v6.388c.02.46.407.817.867.8H30.12a.85.85 0 00.88-.812v-6.188a1.045 1.045 0 00-1.084-1H18.88z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 24.841a.492.492 0 11-.016.984.492.492 0 01.016-.984M18 25.137a9.718 9.718 0 01-8 4.196c-4.519 0-9-3.357-9-7.5 0-4.09 3.545-8.61 6.273-10.5-.786-1.733-1.42-3.1-1.913-4.153a2 2 0 011.812-2.847H14M15.733 14.195a13.466 13.466 0 013.25 7.138",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.772 23.792a2.965 2.965 0 002.477 1.167c1.519 0 2.751-.924 2.751-2.063 0-1.139-1.232-2.061-2.75-2.061-1.52 0-2.75-.924-2.75-2.064 0-1.14 1.232-2.063 2.75-2.063a2.961 2.961 0 012.477 1.167M10.25 24.959v1.374M10.25 15.333v1.375M31 7.048V2.333h-4.715",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 2.336l-4.333 4.33a1.925 1.925 0 01-1.918.484l-4.894-1.308a1.932 1.932 0 00-1.867.5l-4.995 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCashFlow;